// Volání /api/b2b z B2B sekce. Chyba ze serveru se vrací jako Error s českou zprávou,
// u duplicity je v err.duplicita nalezená firma ({ id, nazev, duvod }).
import { apiFetch } from "../../lib/api.js";

async function zpracuj(r) {
  const j = await r.json().catch(() => ({}));
  if (!r.ok) {
    const e = new Error(j.error || `Chyba ${r.status}`);
    if (j.duplicita) e.duplicita = j.duplicita;
    throw e;
  }
  return j;
}

export async function b2bGet(akce, params = {}) {
  const q = new URLSearchParams({ akce, ...Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")) });
  return zpracuj(await apiFetch(`/api/b2b?${q.toString()}`));
}

export async function b2bPost(akce, body = {}) {
  return zpracuj(await apiFetch("/api/b2b", { method: "POST", body: JSON.stringify({ akce, ...body }) }));
}
